export default {"src":"/_next/static/media/Error-img.47e7e7ba.svg","height":246,"width":350};